import { css, Global, withTheme } from '@emotion/react';
import { tooltipCss } from '@chronos/components/Tooltip/styled';
import colorsCss from '@chronos/components/styled/colors';
import 'normalize.css';

const getGlobalStyles = (theme) => css`
  ${colorsCss(theme)}

  html,
  body {
    height: 100%;
  }

  body,
  button,
  html,
  input,
  select,
  textarea {
    color: ${theme.colors.primary};
    font-family:
      -apple-system,
      BlinkMacSystemFont,
      Segoe UI,
      Roboto,
      Noto Sans,
      Ubuntu,
      Droid Sans,
      Helvetica Neue,
      sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }

  #app {
    height: 100%;
  }

  hr {
    box-sizing: content-box;
    overflow: visible;
    background-color: rgba(9, 30, 66, 0.13);
    border: 0;
    height: 1px;
    padding: 0;
    width: 100%;
  }

  ::-webkit-scrollbar {
    height: 0.5rem;
    width: 0.5rem;
  }

  ::-webkit-scrollbar-corner {
    display: none;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 9999px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--background-neutral-hovered);
    border-color: var(--border);
    border-radius: 9999px;
    border-width: 1px;
  }

  ${tooltipCss}
`;

const GlobalStyles = ({ theme }) => <Global styles={getGlobalStyles(theme)} />;

export default withTheme(GlobalStyles);
